import { useCallback } from 'react';
import { useAdminPortalUIConfig } from '../StytchClientContext.mjs';
import { getRoleDefaultDisplayName } from './getRoleDefaultDisplayName.mjs';

const useGetRoleDisplayName = ()=>{
    const config = useAdminPortalUIConfig();
    return useCallback((role)=>{
        return config?.getRoleDisplayName?.(role) || getRoleDefaultDisplayName(role);
    }, [
        config
    ]);
};

export { useGetRoleDisplayName };
//# sourceMappingURL=useGetRoleDisplayName.mjs.map
